
    // this file was auto generated by python script
    import Video from './Video';
    export default Video;
    